<template>
	<div class="navigation">
		<div class="menu-list">
			<div class="menu-list__container">
				<f7-link
					@click="changePageTo('home')"
					id="home"
					:class="currentPage === 'home' ? 'active' : ''">
					<div class="img-wrapper">
						<svg
							viewBox="0 0 20 20"
							fill="currentcolor"
							id="home">
							<path
								d="M7.13478 18.7733V15.7156C7.13478 14.9351 7.77217 14.3023 8.55844 14.3023H11.4326C11.8102 14.3023 12.1723 14.4512 12.4393 14.7163C12.7063 14.9813 12.8563 15.3408 12.8563 15.7156V18.7733C12.8539 19.0978 12.9821 19.4099 13.2124 19.6402C13.4427 19.8705 13.7561 20 14.0829 20H16.0438C16.9596 20.0023 17.8388 19.6428 18.4872 19.0008C19.1356 18.3588 19.5 17.487 19.5 16.5778V7.86686C19.5 7.13246 19.1721 6.43584 18.6046 5.96467L11.934 0.675869C10.7737 -0.251438 9.11111 -0.221498 7.98539 0.746979L1.46701 5.96467C0.872741 6.42195 0.517552 7.12064 0.5 7.86686V16.5689C0.5 18.4639 2.04738 20 3.95617 20H5.87229C6.55123 20 7.103 19.4562 7.10792 18.7822L7.13478 18.7733Z"
								fill="currentcolor" />
						</svg>
					</div>
					<div class="name">Home</div>
				</f7-link>

				<f7-link
					@click="changePageTo('trainings-page')"
					:class="currentPage === 'trainings-page' ? 'active' : ''">
					<div class="img-wrapper">
						<svg
							viewBox="0 0 340 433"
							fill="currentcolor">
							<path
								d="M282.05 88.15C269.193 92.655 255.673 94.98 242.05 95.03C216.274 94.952 191.143 86.966 170.05 72.15C149.074 86.908 124.096 94.917 98.45 95.11C84.688 95.078 71.03 92.725 58.05 88.15V240.15C58.05 251.43 98.05 316.47 170.05 360.15C241.49 316.23 282.05 251.19 282.05 240.15C281.49 207.51 282.05 120.15 282.05 88.15Z" />
							<path
								d="M339.81 27.67C339.845 23.252 336.292 19.642 331.874 19.607C330.722 19.598 329.581 19.838 328.53 20.31C309.146 29.197 288.094 33.86 266.77 33.99C233.616 33.582 201.504 22.344 175.33 1.98999C172.31 -0.663006 167.79 -0.663006 164.77 1.98999C138.642 22.429 106.501 33.677 73.33 33.99C52.006 33.86 30.954 29.197 11.57 20.31C7.54004 18.498 2.80504 20.297 0.993038 24.326C0.521038 25.377 0.281039 26.517 0.290039 27.67C0.290039 29.35 0.850039 194.31 0.290039 248.95C0.290039 278.23 68.13 372.95 165.97 431.03C168.445 432.459 171.495 432.459 173.97 431.03C271.97 372.95 340.13 278.15 339.81 248.87C339.25 194.23 339.81 29.27 339.81 27.67ZM174.13 377.03C171.655 378.459 168.605 378.459 166.13 377.03C92.93 333.67 42.05 262.47 42.05 240.15C42.45 199.67 42.05 77.59 42.05 76.31C42.015 71.892 45.568 68.282 49.986 68.247C51.138 68.238 52.279 68.478 53.33 68.95C67.412 75.426 82.71 78.835 98.21 78.95C122.291 78.824 145.669 70.816 164.77 56.15C167.79 53.497 172.31 53.497 175.33 56.15C194.322 70.886 217.613 79.006 241.65 79.27C257.15 79.155 272.448 75.746 286.53 69.27C290.56 67.458 295.295 69.257 297.107 73.286C297.579 74.337 297.819 75.477 297.81 76.63C298.05 77.83 297.41 200.15 298.05 240.15C298.05 262.47 247.17 333.67 174.13 377.03Z" />
						</svg>
					</div>
					<div class="name">Trainings</div>
				</f7-link>
				<f7-link
					@click="changePageTo('editprofile')"
					:class="currentPage === 'editprofile' ? 'active' : ''">
					<div class="img-wrapper">
						<svg
							viewBox="0 0 16 20"
							fill="currentcolor"
							id="user">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13.294 5.29105C13.294 8.22808 10.9391 10.5831 8 10.5831C5.0619 10.5831 2.70601 8.22808 2.70601 5.29105C2.70601 2.35402 5.0619 0 8 0C10.9391 0 13.294 2.35402 13.294 5.29105ZM8 20C3.66237 20 0 19.295 0 16.575C0 13.8539 3.68538 13.1739 8 13.1739C12.3386 13.1739 16 13.8789 16 16.599C16 19.32 12.3146 20 8 20Z" />
						</svg>
					</div>
					<div class="name">Account</div>
				</f7-link>
				<f7-link
					@click="changePageTo('handbook')"
					:class="currentPage === 'handbook' ? 'active' : ''">
					<div class="img-wrapper">
						<svg
							viewBox="0 0 475.452 475.451"
							fill="currentcolor"
							id="handbook">
							<path
								d="M468.083,118.385c-3.99-5.33-9.61-9.419-16.854-12.275c0.387,6.665-0.086,12.09-1.42,16.281l-85.65,281.789   c-1.526,4.948-4.859,8.897-9.992,11.848c-5.141,2.953-10.469,4.428-15.989,4.428H74.66c-22.84,0-36.542-6.652-41.112-19.985   c-1.903-5.14-1.807-9.229,0.288-12.275c2.092-2.857,5.708-4.288,10.85-4.288h248.102c17.702,0,29.93-3.285,36.688-9.852   c6.763-6.567,13.565-21.177,20.413-43.824l78.228-258.669c4.186-14.084,2.474-26.457-5.141-37.113s-18.462-15.987-32.548-15.987   H173.163c-2.474,0-7.329,0.854-14.562,2.568l0.284-0.859c-5.33-1.14-9.851-1.662-13.562-1.571   c-3.71,0.099-7.137,1.192-10.277,3.289c-3.14,2.094-5.664,4.328-7.566,6.706c-1.903,2.38-3.761,5.426-5.568,9.136   c-1.805,3.715-3.33,7.142-4.567,10.282c-1.237,3.14-2.666,6.473-4.281,9.998c-1.62,3.521-3.186,6.423-4.71,8.706   c-1.143,1.523-2.758,3.521-4.854,5.996c-2.091,2.474-3.805,4.664-5.137,6.567c-1.331,1.903-2.19,3.616-2.568,5.14   c-0.378,1.711-0.19,4.233,0.571,7.566c0.76,3.328,1.047,5.753,0.854,7.277c-0.76,7.232-3.378,16.414-7.849,27.552   c-4.471,11.136-8.52,19.18-12.135,24.126c-0.761,0.95-2.853,3.092-6.28,6.424c-3.427,3.33-5.52,6.23-6.279,8.704   c-0.762,0.951-0.81,3.617-0.144,7.994c0.666,4.38,0.907,7.423,0.715,9.136c-0.765,6.473-3.14,15.037-7.139,25.697   c-3.999,10.657-7.994,19.414-11.993,26.265c-0.569,1.141-2.185,3.328-4.853,6.567c-2.662,3.237-4.283,5.902-4.853,7.99   c-0.38,1.523-0.33,4.188,0.144,7.994c0.473,3.806,0.426,6.66-0.144,8.562c-1.521,7.228-4.377,15.94-8.565,26.125   c-4.187,10.178-8.47,18.896-12.851,26.121c-1.138,1.906-2.712,4.145-4.708,6.711c-1.999,2.566-3.568,4.805-4.711,6.707   c-1.141,1.903-1.903,3.901-2.284,5.996c-0.19,1.143,0.098,2.998,0.859,5.571c0.76,2.566,1.047,4.612,0.854,6.14   c-0.192,2.662-0.57,6.187-1.141,10.567c-0.572,4.373-0.859,6.939-0.859,7.699c-4.187,11.424-3.999,23.511,0.572,36.269   c5.33,14.838,14.797,27.36,28.406,37.541c13.61,10.185,27.74,15.27,42.398,15.27h263.521c12.367,0,24.026-4.141,34.971-12.416   c10.944-8.281,18.227-18.507,21.837-30.696l78.511-258.662C477.412,141.51,475.701,129.234,468.083,118.385z M164.31,118.956   l5.997-18.274c0.76-2.474,2.329-4.615,4.709-6.423c2.38-1.805,4.808-2.712,7.282-2.712h173.589c2.663,0,4.565,0.903,5.708,2.712   c1.14,1.809,1.335,3.949,0.575,6.423l-6.002,18.274c-0.764,2.475-2.327,4.611-4.713,6.424c-2.382,1.805-4.805,2.708-7.278,2.708   H170.593c-2.666,0-4.568-0.9-5.711-2.708C163.74,123.567,163.55,121.431,164.31,118.956z M140.615,192.045l5.996-18.271   c0.76-2.474,2.331-4.615,4.709-6.423c2.38-1.809,4.805-2.712,7.282-2.712h173.583c2.666,0,4.572,0.9,5.712,2.712   c1.14,1.809,1.331,3.949,0.568,6.423l-5.996,18.271c-0.759,2.474-2.33,4.617-4.708,6.423c-2.383,1.809-4.805,2.712-7.283,2.712   H146.895c-2.664,0-4.567-0.9-5.708-2.712C140.043,196.662,139.854,194.519,140.615,192.045z" />
						</svg>
						<span></span>
					</div>
					<div class="name">Handbook</div>
				</f7-link>
				<f7-link
					@click="changePageTo('practice-page')"
					:class="currentPage === 'practice-page' ? 'active' : ''">
					<div class="img-wrapper">
						<div
							class="hipaa-icon-tooth"
							style="font-size: 26px"></div>
					</div>

					<div class="name">Practice</div>
				</f7-link>
				<f7-link @click="logout()">
					<div class="img-wrapper">
						<svg
							fill="currentcolor"
							viewBox="0 0 198.715 198.715">
							<path
								d="M161.463,48.763c-2.929-2.929-7.677-2.929-10.607,0c-2.929,2.929-2.929,7.677,0,10.606
                                c13.763,13.763,21.342,32.062,21.342,51.526c0,19.463-7.579,37.761-21.342,51.523c-14.203,14.204-32.857,21.305-51.516,21.303
                                c-18.659-0.001-37.322-7.104-51.527-21.309c-28.405-28.405-28.402-74.625,0.005-103.032c2.929-2.929,2.929-7.678,0-10.606
                                c-2.929-2.929-7.677-2.929-10.607,0C2.956,83.029,2.953,138.766,37.206,173.019c17.132,17.132,39.632,25.697,62.135,25.696
                                c22.497-0.001,44.997-8.564,62.123-25.69c16.595-16.594,25.734-38.659,25.734-62.129C187.199,87.425,178.059,65.359,161.463,48.763
                                z" />
							<path
								d="M99.332,97.164c4.143,0,7.5-3.358,7.5-7.5V7.5c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v82.164
                                C91.832,93.807,95.189,97.164,99.332,97.164z" />
						</svg>
					</div>
					<div class="name">Logout</div>
				</f7-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			logout: function () {
				this.$store.dispatch("logout");
			},

			changePageTo(path) {
				if (path === "home") path = "";
				f7.views.main.router.navigate(`/${path}`);
			},
		},

		computed: {
			currentPage() {
				return this.$store.state.app.currentPage;
			},
		},
	};
</script>

<style></style>
